export const getStepIndex = (steps, pathname) => {
  const currentStepIndex = steps.findIndex((step) =>
    pathname.endsWith(step.path)
  );
  return currentStepIndex === -1 ? 0 : currentStepIndex;
};
